module.exports = __webpack_public_path__ + "static/media/2 (41).d03da643.jpg";